export const SET_ACTIVE_ANALYSIS_SECTION = 'SET_ACTIVE_ANALYSIS_SECTION';

export const ANALYSIS_PROJECTS_LIST_SECTION = 'list';
export const ANALYSIS_DATA_ANALYSIS_SECTION = 'analysis';

const ANALYSIS_SECTIONS = [ANALYSIS_PROJECTS_LIST_SECTION, ANALYSIS_DATA_ANALYSIS_SECTION];

/**
 * Sets the active section for a single active project
 * @param section
 * @returns {{type: string, section: *}}
 */
export const setActiveAnalysisSection = section => {
  if (ANALYSIS_SECTIONS.indexOf(section) >= 0) {
    return {
      type: SET_ACTIVE_ANALYSIS_SECTION,
      section
    };
  }
};



// WEBPACK FOOTER //
// ./src/scenes/analysis/data/actions.js